export default __webpack_public_path__ + "static/media/hht2_ep16_speaking_04.27b9a4e8.png";